import React from "react";
import PropTypes from "prop-types";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import { FormGroupTitle, FormTextField } from "ui/Form";

import useFormValidator from "hooks/useFormValidator";

import {
  READ_SERVER_SETTINGS_QUERY,
  UPDATE_FTP_SETTINGS,
} from "graphqlQueries/system";

import { FTP_MASQUERADE_ADDRESS_TITTLE } from "constants/repoSettings";
import { FTP_MASQUERADE_ADDRESS } from "constants/mutationArgs/system";

const fieldsWithPlaceForError = [FTP_MASQUERADE_ADDRESS];

const UpdateFtpSettingsDialog = (props) => {
  const { ftpInfo } = props;

  const initialValues = {
    [FTP_MASQUERADE_ADDRESS]: ftpInfo.masquerade_address,
  };

  const { validationSchema } = useFormValidator(
    "update_ftp_masquerade_address",
    {
      masquerade_address: "Masquerade address",
    },
    {},
  );

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_FTP_SETTINGS}
      refetchQueries={[READ_SERVER_SETTINGS_QUERY]}
      initialValues={initialValues}
      validationSchema={validationSchema}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="Edit FTP settings"
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title="FTP information" />
      <FormTextField
        name={FTP_MASQUERADE_ADDRESS}
        label={FTP_MASQUERADE_ADDRESS_TITTLE}
      />
    </DialogFormWithMutation>
  );
};

UpdateFtpSettingsDialog.propTypes = {
  smtpInfo: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UpdateFtpSettingsDialog;
